export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-310x310-ab9aa175b24c5e31aa79d5b6eae1e23f.png";